import { FC } from 'react';
import styled from 'styled-components';
import { Colors, FInter, FlexBox, Button } from '@brg/ui';

export interface BCoreErrorMessageProps {
    title?: string;
    message?: string;
}

const BCoreErrorMessageWrapper = styled(FlexBox)`
    border: 1px solid ${Colors.redFailed};
    background-color: rgba(255, 0, 0, 0.3);
    flex-direction: column;
    border-radius: 8px;
    padding: 8px;
`;

export const BCoreErrorMessage: FC<BCoreErrorMessageProps> = ({ title, message }) => {
    return (
        <FlexBox direction={'column'} gy={8} directionMobile={'column'}>
            <BCoreErrorMessageWrapper gy={8}>
                <FInter.SectionTitleSubtitleBold color={Colors.redFailed}>{title}</FInter.SectionTitleSubtitleBold>
                <FInter.Text>{message}</FInter.Text>
            </BCoreErrorMessageWrapper>
            <Button.YellowMedium onClick={() => (window.location.href = '/')} style={{ borderRadius: 0 }}>
                Перейти на главную страницу
            </Button.YellowMedium>
        </FlexBox>
    );
};
import { FC } from 'react';
import styled from 'styled-components';
import { Colors, FInter, FlexBox, Button } from '@brg/ui';

export interface BCoreErrorMessageProps {
    title?: string;
    message?: string;
}

const BCoreErrorMessageWrapper = styled(FlexBox)`
    border: 1px solid ${Colors.redFailed};
    background-color: rgba(255, 0, 0, 0.3);
    flex-direction: column;
    border-radius: 8px;
    padding: 8px;
`;

export const BCoreErrorMessage: FC<BCoreErrorMessageProps> = ({ title, message }) => {
    return (
        <FlexBox direction={'column'} gy={8} directionMobile={'column'}>
            <BCoreErrorMessageWrapper gy={8}>
                <FInter.SectionTitleSubtitleBold color={Colors.redFailed}>{title}</FInter.SectionTitleSubtitleBold>
                <FInter.Text>{message}</FInter.Text>
            </BCoreErrorMessageWrapper>
            <Button.YellowMedium onClick={() => (window.location.href = '/')} style={{ borderRadius: 0 }}>
                Перейти на главную страницу
            </Button.YellowMedium>
        </FlexBox>
    );
};
